import { gql } from '@apollo/client'

const UPDATE_DIET_IMAGE_DETAILS_MUTATION = gql`
  mutation updateDietImageDetails($id: ID!, $data: DietImageDetailsInput!) {
    updateDietImageDetails(id: $id, data: $data) {
      id
      updatedAt

      updatedBy {
        id
        name
      }

      imageUrl
      onboardingImageUrl
    }
  }
`

export default UPDATE_DIET_IMAGE_DETAILS_MUTATION
